import { useEffect, useState } from "react"
import { getFirebaseAuthInfra } from "@/infrastructure/firebase_auth/client"
import { type User } from "firebase/auth"

export const useCurrentUser = () => {
  const [stateReady, setStateReady] = useState(false)
  const [user, setUser] = useState<User | undefined>(undefined)
  useEffect(() => {
    const auth = getFirebaseAuthInfra()

    // 認証状態の変更を監視
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser ?? undefined)
      if (!stateReady) {
        setStateReady(true)
      }
    })

    return () => unsubscribe()
  }, [stateReady])

  const userResult =
    user != null ? { userId: user.uid, email: user.email } : undefined

  return {
    ...userResult,
    stateReady,
  }
}
